import React, { useContext, useEffect, useState } from "react";
import { Form, Button } from "antd";
import { ModalForm } from "src/enitities/Modal";
import { NomenclatureForm } from "src/enitities/Form";
import { EditOutlined } from "@ant-design/icons";
import { NomenclatureContext } from "src/shared/lib/hooks/context/getNomenclatureContext";

export default function EditNomenclature({
  record,
  handleSave,
  handleDeleteImage,
  handleSaveImage,
}) {
  const { unitsData } = useContext(NomenclatureContext);
  const [isOpen, setOpen] = useState(false);
  const [changeData, setChangeData] = useState(false);
  const [submitIsDisabled, setSubmitDisabled] = useState(false);
  const [form] = Form.useForm();
  const handleSubmit = async (data) => {
    const unit = unitsData.filter((item) => item.id === data[0].unit);
    data[0].id = record.id;
    data[0].unit_name = unit[0].convent_national_view;
    try {
      await handleSave(data[0], "edit");
      setSubmitDisabled(true);
      return true;
    } catch (err) {
      return Promise.reject(err.response?.data.detail[0].msg);
    }
  };

  const handleIsChanges = () => {
    const formDataJSON = JSON.stringify(record);
    const currentDataJSON = JSON.stringify(form.getFieldValue());
    if (formDataJSON !== currentDataJSON) {
      setSubmitDisabled(false);
    } else {
      setSubmitDisabled(true);
    }
  };

  useEffect(() => {
    setSubmitDisabled(false);
  }, [isOpen]);

  return (
    <>
      <Button
        icon={<EditOutlined />}
        onClick={() => setOpen(true)}
        style={{ marginRight: "5px" }}
      />
      {isOpen ? (
        <ModalForm
          formContext={form}
          width={800}
          title={"Редактировать номенклатуру"}
          isOpen={isOpen}
          setOpen={setOpen}
          handleSubmit={handleSubmit}
          submitIsDisabled={submitIsDisabled}
          changeData={changeData}
          setChangeData={setChangeData}
        >
          <NomenclatureForm
            record={record}
            formContext={form}
            handleDeleteImage={handleDeleteImage}
            handleSaveImage={handleSaveImage}
            handleIsChanges={handleIsChanges}
            setChangeData={setChangeData}
          />
        </ModalForm>
      ) : (
        false
      )}
    </>
  );
}
